<script lang="ts">
import { getEnv } from '@monogrid/env'
import { computed, defineComponent, StyleValue } from 'vue'

export default defineComponent({
  name: 'VersionInfo',
  props: {
    /**
     * Determines if the component is automatically positioned
     * in the app in the bottom right corner
     */
    autoPositioned: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Enables copying the version to the clipboard on click of the element
     */
    copyOnClick: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Main version of the site, defaults to `GIT_VERSION` Enviroment variable
     */
    gitTag: {
      type: String,
      required: false,
      default: () => getEnv().GIT_VERSION
    },
    /**
     * Commit hash of the deployed site, defaults to `GIT_HASH` Enviroment variable
     */
    gitHash: {
      type: String,
      required: false,
      default: () => getEnv().GIT_HASH
    },
    /**
     * Branch of deployed site, defaults to `GIT_BRANCH` Enviroment variable
     */
    gitBranch: {
      type: String,
      required: false,
      default: () => getEnv().GIT_BRANCH
    }
  },
  setup (props) {
    const text = computed(() => (`v${props.gitTag} ${props.gitHash} ${props.gitBranch}`))
    const style = computed<StyleValue>(() => ({
      padding: '4px',
      backgroundColor: '#000',
      color: '#fff',
      fontSize: '0.5rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      ...(!props.autoPositioned ? {} : { position: 'fixed', zIndex: 10000, right: 0, bottom: 0 })
    }))

    const onClick = () => {
      console.log(`[VERSION] ${text.value}`)
      if (!props.copyOnClick) return
      const type = 'text/plain'
      const blob = new Blob([text.value], { type })

      if ('clipboard' in navigator) {
        // eslint-disable-next-line no-undef
        const data = [new ClipboardItem({ [type]: blob })]
        navigator.clipboard.write(data).then(() => alert(`'${text.value}' copied to clipboard!`)).catch(e => console.error(e))
      }
    }

    return {
      text,
      style,
      onClick
    }
  }
})
</script>

<template>
  <aside :style="style" @click="onClick">{{ text }}</aside>
</template>
